module.exports = __webpack_public_path__ + "static/media/coins_4.c1fe5097.webp";